module.exports = __webpack_public_path__ + "img/border_et_polygon.66c6f829.svg";